<script setup lang="ts">
    import type { BaseWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    const appStore = useAppStore();

    const pageData = appStore.pageCache;

    /**
     * geometry widget renders only for bikes
     * No types are defined, as it is used via a widget placeholder
     */

    defineProps<IWidgetProps<BaseWidgetData>>();

    const geometry = computed(() => {
        const pageGeometry = pageData?.page?.content?.geometry;
        const data = typeof pageGeometry === 'object' ? pageGeometry : appStore.getReference(pageGeometry);
        // set the wheels to this payload
        if (data) {
            data.wheels = pageData?.page?.product?.wheels;
        }
        return data;
    });

    /**
     * used for woom1plus and woom1
     */
    const defaultModel = 'BikeWoom1';
    const bikeMapper: Record<string, string> = {
        woom1plus: 'BikeWoom1Plus',
        woom2: 'BikeWoom2',
        woom3: 'BikeWoom3',
        woom4: 'BikeWoom4',
        woom5: 'BikeWoom5',
        woom6: 'BikeWoom6',
        explore4: 'BikeExplore',
        explore5: 'BikeExplore',
        explore6: 'BikeExplore',
        woomoff: 'BikeWoomOff',
        woomoffair: 'BikeWoomOffAir',
        woomup: 'BikeWoomUp',
        woomnow: 'BikeWoomNow',
    };

    const bike = computed(() => bikeMapper[geometry.value?.bike as string] || defaultModel);
</script>
<template>
    <lazy-mol-bike-geometry
        v-if="geometry"
        :bike="bike"
        :data="geometry" />
</template>
